module.exports = __webpack_public_path__ + "media/images/projet_05-a68b82e05fe5003ff592589bdbf937d5.jpg";